import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import SimpleModal from 'components/SimpleModal';
import { useEnableDirectDatabaseIntegrationMutation } from 'TeamModule/query/hooks/useEnableDirectDatabaseIntegrationMutation';

export const useEnableDdiModal = () => {
  const { openModal } = useDynamicModal();
  const { enableDirectDatabaseIntegration, isEnablingDirectDatabaseIntegration } =
    useEnableDirectDatabaseIntegrationMutation();

  // No re-entry guard: React commits the dialog + backdrop synchronously on
  // the opening click (discrete-event lane), so a second real click lands on
  // the backdrop and cannot stack another modal.
  const openEnableDdiModal = useCallback(
    ({ teamId }: { teamId: number }) => {
      openModal({
        modal: ({ toggle: closer }) => (
          <SimpleModal
            open
            onClose={closer}
            onConfirm={() => {
              enableDirectDatabaseIntegration({ teamId: String(teamId) });
              closer();
            }}
            closeOnConfirm
            headerText="Enable Direct Database Integration"
            Body={
              <div>
                Enable Direct Database Integration (DDI) for team {teamId}? This provisions a
                read-only database user for the team&apos;s realm.
              </div>
            }
          />
        ),
      });
    },
    [openModal, enableDirectDatabaseIntegration],
  );

  return { openEnableDdiModal, isEnablingDdi: isEnablingDirectDatabaseIntegration };
};

export default useEnableDdiModal;
